import { render, staticRenderFns } from "./ProcNotifParam.vue?vue&type=template&id=fe29f258&"
import script from "./ProcNotifParam.vue?vue&type=script&lang=js&"
export * from "./ProcNotifParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports